<template>
  <v-card>
    <v-card-text>
      <div class="text-h6 mb-4">Aún no tenemos cobertura ahí</div>
      <div>Pero seguro llegaremos próximamente. </div>
      <div>Déjanos tu correo para avisarte cuando estemos listos</div>
      <div>
        <v-text-field
          :rules="[rulesRequired, rulesEmail]"
          v-model="email"
          label="E-mail"
          placeholder="Su correo"
          solo
        ></v-text-field>
        <div v-if="subscribed === true">
          Muchas gracias, le avisaremos tan pronto como nos sea posible
        </div>
        <div v-if="subscribed === false">
          Hubo un error guardando su correo. Inténtelo más tarde
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="!isValidEmail"
        color="amber white--text"
        @click="subscribe"
      >
        Enviar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { queryUrl } from '../utils/http'

const SERVER = 'https://services.plazatodo.com'
const URL_GET_SUBSCRIBE = `${SERVER}/subscribe`

export default {
  data () {
    return {
      email: '',
      validRequiredEmail: false,
      validEmail: false,
      subscribed: null
    }
  },
  computed: {
    isValidEmail () {
      return this.validRequiredEmail && this.validEmail
    }
  },
  methods: {
    rulesRequired (value) {
      const message = 'Obligatorio'
      const result = !!value || message
      this.validRequiredEmail = result !== message
      return result
    },
    rulesEmail (value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const message = 'Correo no valido'
      const result = pattern.test(value) || message
      this.validEmail = result !== message
      return result
    },
    subscribe () {
      queryUrl(`${URL_GET_SUBSCRIBE}/${this.email}/minorista/${this.selectedUbigeo}`)
        .then(() => {
          this.subscribed = true
        })
        .catch(() => {
          this.subscribed = false
        })
    }
  },
  props: {
    selectedUbigeo: {
      type: String,
      required: true
    }
  }
}
</script>
